import {
  GET_RESERVATION_TYPE_SUCCESS,
  RESERVATION_TYPE_REQUESTING,
  LIST_RESERVATION_TYPES_SUCCESS,
  RESET_RESERVATION_TYPE_ISFETCHING
} from './constants';

const INITIAL_STATE = {
  data: null,
  isFetching: false
};

const reducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case RESET_RESERVATION_TYPE_ISFETCHING: {
      return {
        ...state,
        isFetching: false
      };
    }
    case RESERVATION_TYPE_REQUESTING: {
      return {
        ...state,
        isFetching: true
      };
    }
    case LIST_RESERVATION_TYPES_SUCCESS: {
      const data = { ...state.data };
      action.payload.reservationTypes.forEach((object) => {
        data[object.id] = object;
      });
      return {
        data,
        isFetching: false
      };
    }
    case GET_RESERVATION_TYPE_SUCCESS: {
      const data = { ...state.data };
      data[action.payload.id] = action.payload;
      return {
        data,
        isFetching: false
      };
    }
    default:
      return state;
  }
};

export default reducer;

export const getReservationTypeBySlug = (reservationTypes, slug) => {
  if (!reservationTypes || !reservationTypes.data) {
    return null;
  }
  const reservationTypeIds = Object.keys(reservationTypes.data);
  const reservationTypeBySlugId = reservationTypeIds.find(
    (id) => reservationTypes.data[id].slug === slug
  );
  if (reservationTypeBySlugId) {
    return reservationTypes.data[reservationTypeBySlugId];
  }
  return null;
};
